import { render, staticRenderFns } from "./collectReport.vue?vue&type=template&id=8c9137e0&scoped=true"
import script from "./collectReport.vue?vue&type=script&lang=js"
export * from "./collectReport.vue?vue&type=script&lang=js"
import style0 from "./collectReport.vue?vue&type=style&index=0&id=8c9137e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c9137e0",
  null
  
)

export default component.exports